import { createRoute } from '@tanstack/react-router';

import { ForbiddenPage } from 'src/pages/errors/ForbiddenPage';
import { RootRoute } from 'src/routes/__root';

export const ForbiddenRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/forbidden',
  component: () => <ForbiddenPage />,
});

export const ForbiddenDefaultRoute = createRoute({
  getParentRoute: () => ForbiddenRoute,
  path: '/',
  component: ForbiddenPage,
});
